import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api"; // همان اینستنس Axios پروژه

export default function CampaignBannersSection() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const fetchActiveCampaigns = async () => {
      try {
        setLoading(true);
        const response = await api.get("/home/campaigns/active/");
        if (isMounted) {
          setCampaigns(Array.isArray(response.data) ? response.data : []);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          console.error("خطا در دریافت کمپین‌های فعال:", err);
          setError("خطا در بارگذاری جشنواره‌ها");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchActiveCampaigns();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleCampaignClick = (slug) => {
    navigate(`/shopping/product-list/?campaign_slug=${slug}`);
  };

  // اسکلتون لودینگ — هماهنگ با توکن gray-200 سیستم طراحی
  if (loading) {
    return (
      <section className="container mx-auto my-6 px-4">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {[1, 2].map((item) => (
            <div
              key={item}
              className="h-44 sm:h-52 md:h-64 w-full animate-pulse rounded-2xl bg-gray-200"
            />
          ))}
        </div>
      </section>
    );
  }

  // خالی بودن لیست: چیزی نمایش داده نشود
  if (!error && !campaigns.length) {
    return null;
  }

  return (
    <section className="container mx-auto my-8 px-4" aria-label="جشنواره‌ها و کمپین‌های فعال">
      {error ? (
        // حالت خطا با توکن‌های رسمی سیستم طراحی (مشابه حالت خالی جدول)
        <div className="rounded-2xl border border-gray-200 bg-white py-10 text-center text-sm text-gray-500 shadow-sm">
          {error}
        </div>
      ) : (
        <div
          className={`grid gap-5 ${
            campaigns.length === 1 ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2"
          }`}
        >
          {campaigns.map((campaign) => (
            <div
              key={campaign.id}
              onClick={() => handleCampaignClick(campaign.slug)}
              className="group relative cursor-pointer overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              {/* تصویر ریسپانسیو بنر */}
              <picture className="block w-full">
                {campaign.mobile_banner && (
                  <source
                    media="(max-width: 640px)"
                    srcSet={campaign.mobile_banner}
                  />
                )}
                <img
                  src={campaign.desktop_banner || campaign.mobile_banner}
                  alt={campaign.title || "بنر کمپین"}
                  loading="lazy"
                  className="h-48 sm:h-56 md:h-64 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </picture>

              {/* گرادینت تاریک پایین بنر برای خوانایی متن و دکمه */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent transition-opacity group-hover:from-black/80" />

              {/* محتوای روی بنر شامل متن و دکمه CTA */}
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4 sm:p-6 text-white">
                <div className="max-w-[65%] space-y-1">
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold tracking-tight text-white drop-shadow-sm">
                    {campaign.title}
                  </h3>
                  {campaign.description && (
                    <p className="line-clamp-1 text-xs sm:text-sm text-gray-200 drop-shadow-sm">
                      {campaign.description}
                    </p>
                  )}
                </div>

                {/* دکمه CTA — مطابق variant "primary" سیستم طراحی */}
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCampaignClick(campaign.slug);
                  }}
                  className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-[#1E3A5F] px-3.5 py-2 text-xs font-medium text-[#FFC107] shadow-md transition-colors duration-200 hover:bg-[#2B5388] hover:text-[#D19D00] active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 sm:text-sm"
                >
                  <span>مشاهده کالاها</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 rotate-180 transform transition-transform group-hover:-translate-x-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}